import { GridReadyEvent } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { JoStatus } from 'app/model/entities/jo-status';
import { AgFns, GridOptionsExt, ISortModel } from 'app/shared/ag-fns';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { DomainService } from 'app/shared/domain.service';
import { NavFnsPng } from 'app/shared/nav-fns-png';
import { UtilFns } from 'app/shared/util-fns';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface JoStatsDialogParams extends DialogParams {
  joStatusId: string
  dateInMonth: Date;
}

@Component({
    templateUrl: './jo-stats-dialog.component.html',
    standalone: false
})
export class JoStatsDialogComponent extends DialogBaseComponent<JoStatsDialogParams>  {

  johGridOptions: GridOptionsExt;

  constructor( public config: DynamicDialogConfig<JoStatsDialogParams>, public dialogRef: DynamicDialogRef, 
    public domainService: DomainService, private router: Router) {
      super(config, dialogRef, domainService);
      Object.assign(this.config, {
        header: "Purchase Order Instructions",
        width: '1000px',
        height: '570px',
      })
    
      this.prepare();
    }

  async prepare() {
    const joStatuses = this.dbQueryService.getAllCached(JoStatus);
    const joStatusName = joStatuses.find(s => s.id == this.params.joStatusId).name;
    const monthName = this.formatDateAsMonth(this.params.dateInMonth);
    this.config.header = `Job Orders for ${monthName} with status: '${joStatusName}'`;
    this.johGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onJohGridReady,
      rowModelType: 'serverSide',
    });
    this.isPageReady = true;
  }

  async onJohGridReady(event: GridReadyEvent) {

    const colDefs = [
      { headerName: 'Job Order', field: 'id', filter: 'agNumberColumnFilter', ...NavFnsPng.createIdCellClickedNavProps('id', this.router, ['/job-orders'], this.dialogRef),   },
      { headerName: 'Account', field: 'account.accountName', filter: 'agTextColumnFilter' },
      { headerName: 'Status', field: 'joStatus.name'  },
      { headerName: 'J/O Date', field: 'joDate', filter: 'agDateColumnFilter' },
      
      
      { headerName: 'CrtnTs', field: 'crtnTs', filter: 'agDateColumnFilter' },
    ];
    const sortModel = [
      { colId: 'id', sort: 'asc' },
      { colId: 'crtnTs', sort: 'asc' },
    ] as ISortModel;

    // next line is needed by the buildDatasource method
    AgFns.initGrid(event, colDefs, sortModel);
    
    await UtilFns.wait(0);
    this.updateDatasource();
  }

  updateDatasource() {
    const gridApi = this.johGridOptions.apiX;
    if (gridApi == null) return;
    const ds = AgFns.buildDatasource(() => this.dbQueryService.createJoHeaderQueryForStatusAndMonthOf(this.params.joStatusId, this.params.dateInMonth));
    gridApi.setGridOption('serverSideDatasource', ds);
  }

  formatDateAsMonth(date: Date) {
    const options = { year: 'numeric', month: 'long',  } as any;
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }


  async ok() {
    this.dialogRef.close(true);
  }

}
